<template>
  <div>
    <el-card class="mat12">
      <el-row>
        <!-- <el-col
          :span="6"
          class="media_col padding-tb10 cell el-tooltip"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>合同起始：</h4>
          {{ staffDetail.staffStation.contractBeginTime }}
          <i
            class="el-icon-view view_history"
            v-popover:popover1
            v-if="isCheck"
          ></i>
          <el-popover
            ref="popover1"
            placement="right"
            title="合同起始："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractBeginTime"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>合同截止：</h4>
          <span
            :class="isExpire == 2 ? 'red' : isExpire == 1 ? 'wraning' : ''"
            >{{ staffDetail.staffStation.contractEndTime }}</span
          >
          <i
            class="el-icon-view view_history"
            v-popover:popover2
            v-if="isCheck"
          ></i>
          <el-popover
            ref="popover2"
            placement="right"
            title="合同截止："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractEndTime"
          ></el-popover>
        </el-col> -->

        <el-col
          :span="6"
          class="media_col padding-tb10 cell el-tooltip"
          :class="{ contrast: isCheck }"
          v-if="staffDetail.staffStation.probationBeginTime"
        >
          <span v-if="isCheck">*</span>
          <h4>试用期起始：</h4>
          {{ staffDetail.staffStation.probationBeginTime }}
          <i
            class="el-icon-view view_history"
            v-popover:popover1
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover1"
            placement="right"
            title="试用期起始："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.probationBeginTime"
          ></el-popover>
        </el-col>

        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
          v-if="staffDetail.staffStation.probationEndTime"
        >
          <span v-if="isCheck">*</span>
          <h4>试用期截止：</h4>
          <span
            :class="isExpire == 2 ? 'red' : isExpire == 1 ? 'wraning' : ''"
            >{{ staffDetail.staffStation.probationEndTime }}</span
          >
          <i
            class="el-icon-view view_history"
            v-popover:popover2
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover2"
            placement="right"
            title="试用期截止："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.probationEndTime"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>试用期期限：</h4>
          {{ staffDetail.staffStation.prolevel }}
          <i
            class="el-icon-view view_history"
            v-popover:popover13
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover13"
            placement="right"
            title="试用期期限："
            width="200"
            trigger="click"
          >
            <span slot="content">{{ staffDetail.staffStation.prolevel }} </span>
          </el-popover>
        </el-col>

        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>职级：</h4>
          {{ filterLeave(staffDetail.staffStation.level) }}
          <i
            class="el-icon-view view_history"
            v-popover:popover13
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover13"
            placement="right"
            title="职级："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.level"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>是否在职：</h4>
          {{ staffDetail.staffBasis.quitStatus == 0 ? "是" : "否" }}
          <i
            class="el-icon-view view_history"
            v-popover:popover3
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover3"
            placement="right"
            title="是否在职："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.quitStatus == 0 ? '是' : '否'"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>工龄：</h4>
          {{
            staffDetail.staffStation.workingYearsDay
              ? staffDetail.staffStation.workingYearsDay
              : "0"
          }}
          
          <i
            class="el-icon-view view_history"
            v-popover:popover4
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover4"
            placement="right"
            title="工龄："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.workingYearsDay"
          ></el-popover>
        </el-col>
        <!-- <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>试用期工资：</h4>
          {{ staffDetail.staffStation.probationSalary }}
          <i
            class="el-icon-view view_history"
            v-popover:popover5
            v-if="isCheck"
          ></i>
          <el-popover
            ref="popover5"
            placement="right"
            title="试用期工资："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.probationSalary + ''"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>转正后工资：</h4>
          {{ staffDetail.staffStation.officialSalary }}
          <i
            class="el-icon-view view_history"
            v-popover:popover6
            v-if="isCheck"
          ></i>
          <el-popover
            ref="popover6"
            placement="right"
            title="转正后工资："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.officialSalary + ''"
          ></el-popover>
        </el-col> -->
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>所属公司：</h4>
          {{ campanyName }}
          <i
            class="el-icon-view view_history"
            v-popover:popover7
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover7"
            placement="right"
            title="所属公司："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractBeginTime"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10 ellipsis"
          :class="{ contrast: isCheck }"
          :title="projectName"
        >
          <span v-if="isCheck">*</span>
          <h4>所属项目：</h4>
          {{ projectName }}
          <i
            class="el-icon-view view_history"
            v-popover:popover8
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover8"
            placement="right"
            title="所属项目："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractBeginTime"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>项目所属公司：</h4>
          {{ projectCompanyName }}
          <i
            class="el-icon-view view_history"
            v-popover:popover8
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover8"
            placement="right"
            title="目所属公司"
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractBeginTime"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10 "
          v-if="staffDetail.staffStation.authority"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>用户层级：</h4>
          {{ staffDetail.staffStation.authority }}
          <i
            class="el-icon-view view_history"
            v-popover:popover9
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover9"
            placement="right"
            title="用户层级："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.authority"
          ></el-popover>
        </el-col>

        <el-col
          :span="6"
          class="media_col padding-tb10 "
          v-if="staffDetail.staffStation"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>所属职务：</h4>
          {{ getPosition(staffDetail.staffStation.post) }}
          <i
            class="el-icon-view view_history"
            v-popover:popover9
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover9"
            placement="right"
            title="所属职务："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractBeginTime"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>所属岗位：</h4>
          {{ postName ? postName : "无" }}
          <i
            class="el-icon-view view_history"
            v-popover:popover10
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover10"
            placement="right"
            title="所属岗位："
            width="200"
            trigger="click"
            :content="postName"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>员工来源：</h4>
          {{ staffDetail.staffStation.source }}
          <i
            class="el-icon-view view_history"
            v-popover:popover11
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover11"
            placement="right"
            title="员工来源："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.source"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          v-if="staffDetail.staffStation.source === '熟人介绍'"
        >
          <h4>介绍人：</h4>
          {{ staffDetail.staffStation.introduceName }}
        </el-col>

        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>备注：</h4>
          {{
            staffDetail.staffStation.mark ? staffDetail.staffStation.mark : "无"
          }}
          <i
            class="el-icon-view view_history"
            v-popover:popover12
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover12"
            placement="right"
            title="备注："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.mark"
          ></el-popover>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { CompanyDetail } from '@/api/company.js'
import { ProjectdName, ProjectPostById } from '@/api/project.js'
import { PersonalPost, StaffStationPost } from '@/utils/config.js'
export default {
  name: 'CardJobInfo',
  props: {
    staffDetail: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      campanyName: '',
      postName: '',
      projectName: '',
      PersonalPost,
      StaffStationPost,
      projectCompanyName: '', // 项目所属公司
      isCheck: false // 临时
    }
  },
  beforeCreate () {
    self = this // 指定指向问题
  },
  created () {
    // console.log(this)
    // console.log(this.PersonalPost);
  },
  computed: {
    isExpire () {
      let flag = 3 // moren
      let newdDate = new Date().getTime()
      let oldDate = new Date(
        this.staffDetail.staffStation.contractEndTime
      ).getTime()
      //  差值 转换成天数
      let val = Math.floor((oldDate - newdDate) / 1000 / 60 / 60 / 24)
      if (val <= 45 && val > 30) {
        flag = '1'
      } else if (val <= 30) {
        flag = '2'
      } else {
        flag = '3'
      }
      return flag
    }
  },
  methods: {
    filterLeave (value) {
      let arr = self.PersonalPost.filter((item) => {
        return item.id == value
      })
      if (arr.length > 0) {
        return arr[0].label
      } else {
        return '无'
      }
    },
    getPosition (post) {
      let label = ''
      StaffStationPost.forEach(item => {
        if (Number(item.value) === Number(post)) {
          label = item.label
        }
      })
      return label
    },
    initData (companyId, projectId, postId, projectIds) {
      this.getCurrentCompanyName(companyId)
      this.getCurrentProjectName(projectId, projectIds)
      this.getCurrentPostName(projectId, postId)
    },
    async getCurrentCompanyName (companyId) {
      var id = companyId
      var c = { id }
      let result = await CompanyDetail(c)

      if (result) {
        this.campanyName = result.data.companyName
      }
    },

    async getCurrentProjectName (projectId, projectIds) {
      let projectCompanyId = ''
      if (!projectId) {
        // 如果存在
        let arr = projectIds.split(',')
        // 因为传递的时候会多一个逗号，所以需要去掉最后一位
        arr.pop()
        let result1 = await ProjectdName({ projectId: arr[0] })
        let result2 = arr[1] ? await ProjectdName({ projectId: arr[1] }) : ''
        this.projectName =
          result1.data.projectName +
          (result2 ? ',' + result2.data.projectName : '')
        projectCompanyId = result1.data.companyId + (result2 ? ',' + result2.data.companyId : '')
      } else {
        let arr = projectIds ? projectIds.split(',') : []
        arr.pop()
        if (arr.length > 1) {
          let result1 = await ProjectdName({ projectId: arr[0] })
          let result2 = arr[1] ? await ProjectdName({ projectId: arr[1] }) : ''
          this.projectName =
            result1.data.projectName +
            (result2 ? ',' + result2.data.projectName : '')
          projectCompanyId = result1.data.companyId + (result2 ? ',' + result2.data.companyId : '')
        } else {
          let result = await ProjectdName({ projectId })
          this.projectName = result.data.projectName
          projectCompanyId = result.data.companyId
        }
      }
      // 处理公司显示
      let arr = projectCompanyId ? projectCompanyId.toString().split(',') : []
      let list = this.$store.state.company.companyList.slice()
      let names = []
      if (arr.length) {
        arr.forEach(item => {
          list.forEach(company => {
            if (item == company.id) {
              names.push(company.companyName)
            }
          })
        })
      }
      this.projectCompanyName = Array.from(new Set(names)).join()
    },

    async getCurrentPostName (projectId, postId) {
      // var id = postId;
      if (postId != null) {
        var p = { projectId, postId }
        let result = await ProjectPostById(p)
        var postList = result.data
        if (postList.length > 0) {
          var post = postList[0]
          this.postName = post.postName
        }
      }
    },
    handleEmit () {
      this.$emit('savedata', {})
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #409eff;
.contrast {
  color: $color;
}
.view_history {
  cursor: pointer;
  margin-left: 10px;
}
.red {
  color: #ff0000;
}
.wraning {
  color: #d38b00;
}
</style>
